import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Optional, Silent } from "@/__main__/data-model.mjs";
import { playerWeaponStat } from "@/game-fortnite/models/player-weapon-stats.mjs";

const baseMatch = {
  gameId: String,
  startedAt: Date,
  seasonId: Number,
};

const matchlist = {
  ...baseMatch,
  isZeroBuild: Boolean,
  isRanked: Boolean,
  mode: String,
} satisfies ModelDefinition;

export const playerMatch = {
  match: matchlist,
  kills: Number,
  killsHist: Number,
  assists: Number,
  downs: Number,
  revives: Number,
  accuracy: Number,
  accuracyHist: Number,
  damageDealt: Number,
  damageDealtHist: Number,
  damageTaken: Number,
  distanceTraveled: Number,
  headshotPercentage: Number,
  headshotPercentageHist: Silent(Number),
  aliveTime: Number,
  aliveTimeHist: Number,
  placement: Number,
  woodGathered: Number,
  woodUsed: Number,
  stoneGathered: Number,
  stoneUsed: Number,
  metalGathered: Number,
  metalUsed: Number,
  totalHeadshots: Number,
  totalHits: Number,
  weaponStats: [playerWeaponStat],
  character: Optional(String),
} satisfies ModelDefinition;

const validateFn = createModel({
  data: {
    player: {
      playerMatches: [playerMatch],
    },
  },
}).transform([playerMatch], (response) => response.data.player.playerMatches);

export type Matchlist = FromModel<typeof baseMatch>;
export type PlayerMatch = FromModel<typeof playerMatch>;
export type PlayerMatches = FromModel<typeof validateFn>;

export default validateFn;
